import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Link to the Privacy Policy page. Scrolling to top is handled globally
 * by the ScrollToTop component.
 */
const PrivacyPolicyLink = ({ children, className }) => (
  <Link to="/privacy-policy" className={className}>
    {children || 'Privacy Policy'}
  </Link>
);

export default PrivacyPolicyLink;
